import utils from '../../utils'

let global = utils.global || {};
let ZJApp = global.ZJApp = global.ZJApp || {};
let ZJPlugins = ZJApp.ZJPlugins = ZJApp.ZJPlugins || {};

let _pluginsLoader = null;

// 加载插件
let loadAllPlugins = function() {
    if (!_pluginsLoader) {
        _pluginsLoader = import(/* webpackChunkName: 'client' */ './plugins');
        _pluginsLoader.then(plugins=>{
            plugins = plugins.default;
            //安装插件
            utils.each(plugins, x=>{
                ZJPlugins[x.name] = x;
                if (typeof x.install === 'function') {
                    x.install.apply(x, [ZJApp]);
                }
            });
        });
    }
    return _pluginsLoader;
};

ZJPlugins.findPlugin = function(uri) {
    let name = uri.host;
    return new Promise(function (resolve, reject) {
        // 加载所有插件
        loadAllPlugins()
        .then(()=>{

            //查找插件
            let plugin = null;
            utils.each(ZJPlugins, x=>{
                if (typeof x === 'object' && x.name &&
                    x.name.toLowerCase() == name.toLowerCase()) {
                    plugin = x;
                    return false;
                }
            });

            //返回
            if (!plugin || (typeof plugin === 'undefined')) {
                reject('未找到插件 ' + name);
            }
            else {
                resolve(plugin);
            }
        })
        .catch(e=>reject('未找到插件 ' + name + ': ' + e));
    });
};

ZJPlugins._getComponent = function(opts) {
    let uri = utils.parseUrl(opts.url);
    ZJPlugins.findPlugin(uri)
    .then(plugin=>{
        plugin.getView.apply(plugin, [uri])
        .then(view=>opts.resolve({
            url: opts.url,
            uri: uri,
            plugin: plugin,
            component: view
        }))
        .catch(e=>opts.reject(e));
    })
    .catch(e=>{
        opts.reject(e);
    });
};

ZJPlugins.getComponent = function(url, progress) {
    return new Promise(function (resolve, reject) {
        ZJPlugins._getComponent({
            url,
            progress,
            resolve,
            reject,
        });
    });
};

export default ZJPlugins